module.exports = __webpack_public_path__ + "static/media/guidr.7cb26fb0.png";